export default "__VITE_ASSET__U9nYn60y__"